import { render, staticRenderFns } from "./dictDataPanel.vue?vue&type=template&id=06c8bcc0&scoped=true&"
import script from "./dictDataPanel.vue?vue&type=script&lang=js&"
export * from "./dictDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./dictDataPanel.vue?vue&type=style&index=0&id=06c8bcc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c8bcc0",
  null
  
)

export default component.exports